import { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

const RedirectComponent: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  useEffect(() => {
    if (id) {
      history.replace({
        pathname: '/ListaExtratos',
        state: { id },
      });
    }
  }, [id, history]);

  return null;
};

export default RedirectComponent;